import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { environment } from '@environments/environment';
import { IonFooter, ModalController } from '@ionic/angular';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsOfUseComponent implements AfterViewInit {
    @ViewChild(IonFooter) footer: any;

    email = environment.support.email;

    constructor(
        private modalController: ModalController
    ) {}

    ngAfterViewInit(): void {
        this.footer.el.style.opacity = 1; // Hack to solve issue with iOS
    }

    onClose(): void {
        this.modalController.dismiss();
    }

    async onOpenPrivacyPolicy(): Promise<void> {
        const modal = await this.modalController.create({
            component: PrivacyPolicyComponent
        });
        return await modal.present();
    }
}
